import { CodiceDescrizione } from "../types/types";

export const regioni: CodiceDescrizione<number, string>[] = [
    { codice: 1, descrizione: "Abruzzo" },
    { codice: 2, descrizione: "Basilicata" },
    { codice: 3, descrizione: "Bolzano" },
    { codice: 4, descrizione: "Calabria" },
    { codice: 5, descrizione: "Campania" },
    { codice: 6, descrizione: "Emilia Romagna" },
    { codice: 7, descrizione: "Friuli Venezia Giulia" },
    { codice: 8, descrizione: "Lazio" },
    { codice: 9, descrizione: "Liguria" },
    { codice: 10, descrizione: "Lombardia" },
    { codice: 11, descrizione: "Marche" },
    { codice: 12, descrizione: "Molise" },
    { codice: 13, descrizione: "Piemonte" },
    { codice: 14, descrizione: "Puglia" },
    { codice: 15, descrizione: "Sardegna" },
    { codice: 16, descrizione: "Sicilia" },
    { codice: 17, descrizione: "Toscana" },
    { codice: 18, descrizione: "Trento" },
    { codice: 19, descrizione: "Umbria" },
    { codice: 20, descrizione: "Valle d'Aosta" },
    { codice: 21, descrizione: "Veneto" }
]

// Constanti per i vari Guid delle applicazioni
export const ApplicazioniValue = {
    Forfetari: 'DBE4A355-F85E-4911-96EA-36330E2CBEF3',
    EasyStart: '41416934-83D0-41E2-976B-4821E13C8462',
    Budget4u: '79C7462F-F461-4918-811D-A75AF852226F',
    ConvSrl: '8DB6B799-2A17-490D-804A-20D51A40D3B3'
}

export type SsoType = 'sso' | 'ssosix';